import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './Sidebar.css';

function Sidebar({ onLogout, isStaff, user }) {
  const navigate = useNavigate();
  const location = useLocation();

  const allMenuItems = [
    { path: '/', label: 'Dashboard', icon: '📊', adminOnly: true },
    { path: '/requests', label: 'Activation Requests', icon: '📋', adminOnly: false },
    { path: '/licenses', label: 'Licenses', icon: '🔑', adminOnly: true },
    { path: '/customers', label: 'Customers', icon: '👥', adminOnly: true },
    { path: '/activity', label: 'User Activity', icon: '📈', adminOnly: true },
    { path: '/geo', label: 'Geo Analytics', icon: '🌍', adminOnly: true },
  ];

  const menuItems = allMenuItems.filter(item => {
    if (isStaff) return !item.adminOnly;
    return true;
  });

  return (
    <div className="sidebar">
      <div className="sidebar-header">
        <h1>CivilCADPro</h1>
        <span>Activation Panel</span>
      </div>
      <nav className="sidebar-nav">
        {menuItems.map(item => (
          <div
            key={item.path}
            className={`nav-item ${location.pathname === item.path ? 'active' : ''}`}
            onClick={() => navigate(item.path)}
          >
            <span className="nav-icon">{item.icon}</span>
            <span>{item.label}</span>
          </div>
        ))}
      </nav>
      <div className="sidebar-footer">
        <button onClick={onLogout} className="btn-logout">Logout</button>
      </div>
    </div>
  );
}

export default Sidebar;